"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHBCalloutBannerStyles = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _colors = _interopRequireDefault(require("../../styles/colors"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var STYLES_PER_TYPE_PER_THEME = {
  neutral: {
    neutral: {
      backgroundColor: _colors["default"].white,
      shadow: true,
      accentLineColor: _colors["default"].purpleHeart,
      textColor: 'neutral900',
      primaryActionButtonTheme: 'primary',
      primaryActionLinkButtonTheme: 'solid',
      secondaryActionButtonTheme: 'secondary-invisible-secondary',
      closeColor: _colors["default"].neutral900
    },
    accent: {
      backgroundColor: _colors["default"].purple_20,
      shadow: false,
      accentLineColor: _colors["default"].purpleHeart,
      textColor: 'neutral900',
      primaryActionButtonTheme: 'primary',
      primaryActionLinkButtonTheme: 'solid',
      secondaryActionButtonTheme: 'secondary-invisible-secondary',
      closeColor: _colors["default"].neutral900
    }
  },
  brand: {
    neutral: {
      backgroundColor: _colors["default"].merino500,
      shadow: false,
      accentLineColor: _colors["default"].transparent,
      textColor: 'neutral900',
      primaryActionButtonTheme: 'primary',
      primaryActionLinkButtonTheme: 'solid',
      secondaryActionButtonTheme: 'secondary-invisible-secondary',
      closeColor: _colors["default"].neutral900
    },
    accent: {
      backgroundColor: _colors["default"].neutral900,
      shadow: false,
      accentLineColor: _colors["default"].transparent,
      textColor: 'white',
      primaryActionButtonTheme: 'secondary-solid-primary',
      primaryActionLinkButtonTheme: 'secondary',
      secondaryActionButtonTheme: 'secondary-translucent-secondary',
      closeColor: _colors["default"].white
    }
  }
};
var STYLES_PER_SIZE = {
  sm: {
    padding: 16,
    titleType: 'title16',
    descriptionType: 'body14',
    buttonSize: 'xs',
    linkButtonSize: 'sm'
  },
  md: {
    padding: 20,
    titleType: 'title18',
    descriptionType: 'body16',
    buttonSize: 'sm',
    linkButtonSize: 'md'
  },
  lg: {
    padding: 24,
    titleType: 'display24',
    descriptionType: 'body18',
    buttonSize: 'md',
    linkButtonSize: 'lg'
  }
};
var SQUARE_ILLUSTRATION_PLACEHOLDER_MAP = {
  sm: 205,
  md: 225,
  lg: 250
};
var ASPECT_RATIO_MAP = {
  '1:1': 1,
  '4:3': 4 / 3,
  '3:2': 3 / 2,
  '16:9': 16 / 9,
  '2:1': 2
};
var useHBCalloutBannerStyles = exports.useHBCalloutBannerStyles = function useHBCalloutBannerStyles(type, theme, size, illustrationAspectRatio, illustrationOrientation) {
  var getIllustrationPlaceholder = (0, _react.useCallback)(function (bannerSize) {
    var _SQUARE_ILLUSTRATION_, _ASPECT_RATIO_MAP$ill, _STYLES_PER_SIZE$bann;
    var squareIllustrationPlaceholder = (_SQUARE_ILLUSTRATION_ = SQUARE_ILLUSTRATION_PLACEHOLDER_MAP === null || SQUARE_ILLUSTRATION_PLACEHOLDER_MAP === void 0 ? void 0 : SQUARE_ILLUSTRATION_PLACEHOLDER_MAP[bannerSize]) !== null && _SQUARE_ILLUSTRATION_ !== void 0 ? _SQUARE_ILLUSTRATION_ : SQUARE_ILLUSTRATION_PLACEHOLDER_MAP.sm;
    var aspectRatioOrientationPower = illustrationOrientation === 'landscape' ? 1 : -1;
    var aspectRatio = Math.pow((_ASPECT_RATIO_MAP$ill = ASPECT_RATIO_MAP === null || ASPECT_RATIO_MAP === void 0 ? void 0 : ASPECT_RATIO_MAP[illustrationAspectRatio]) !== null && _ASPECT_RATIO_MAP$ill !== void 0 ? _ASPECT_RATIO_MAP$ill : ASPECT_RATIO_MAP['1:1'], aspectRatioOrientationPower);
    var contentPadding = (_STYLES_PER_SIZE$bann = STYLES_PER_SIZE[bannerSize].padding) !== null && _STYLES_PER_SIZE$bann !== void 0 ? _STYLES_PER_SIZE$bann : STYLES_PER_SIZE.sm.padding;
    return Math.round(squareIllustrationPlaceholder * aspectRatio) + contentPadding;
  }, [illustrationAspectRatio, illustrationOrientation]);
  return (0, _react.useMemo)(function () {
    var _STYLES_PER_TYPE_PER_, _STYLES_PER_TYPE_PER_2, _STYLES_PER_SIZE$size;
    var stylesPerTypePerTheme = (_STYLES_PER_TYPE_PER_ = STYLES_PER_TYPE_PER_THEME === null || STYLES_PER_TYPE_PER_THEME === void 0 || (_STYLES_PER_TYPE_PER_2 = STYLES_PER_TYPE_PER_THEME[type]) === null || _STYLES_PER_TYPE_PER_2 === void 0 ? void 0 : _STYLES_PER_TYPE_PER_2[theme]) !== null && _STYLES_PER_TYPE_PER_ !== void 0 ? _STYLES_PER_TYPE_PER_ : STYLES_PER_TYPE_PER_THEME.neutral.neutral;
    var sizeLimit = size;
    if (type === 'neutral' && size === 'lg') {
      sizeLimit = 'md';
    }
    var stylesPerSize = (_STYLES_PER_SIZE$size = STYLES_PER_SIZE === null || STYLES_PER_SIZE === void 0 ? void 0 : STYLES_PER_SIZE[sizeLimit]) !== null && _STYLES_PER_SIZE$size !== void 0 ? _STYLES_PER_SIZE$size : STYLES_PER_SIZE.sm;
    var illustrationPlaceholder = getIllustrationPlaceholder(sizeLimit);
    return _objectSpread(_objectSpread(_objectSpread({}, stylesPerTypePerTheme), stylesPerSize), {}, {
      illustrationPlaceholder: illustrationPlaceholder
    });
  }, [getIllustrationPlaceholder, size, theme, type]);
};
//# sourceMappingURL=useHBCalloutBannerStyles.js.map